import { render, staticRenderFns } from "./tenantTwo.vue?vue&type=template&id=7cdb1f07"
import script from "./tenantTwo.vue?vue&type=script&lang=js"
export * from "./tenantTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports